_go: function | null = null

def register(fn: function) {
  _go := fn
}

def go(path: string) {
  if !_go {
    throw new Error('No router registered. Make sure a Router instance is created before navigating.')
  }
  return _go(path)
}
